// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import xcouncilEntity from './entities/xcouncil.json';
import xcouncilMenu from '../pages/xcouncil/menu.json';
import xcouncilFullForm from '../pages/xcouncil/forms/full.json';
import xcouncilContextForm from '../pages/xcouncil/forms/context.json';
import xcouncilMiniForm from '../pages/xcouncil/forms/mini.json';
import xcouncilLookupForm from '../pages/xcouncil/forms/lookup.json';
import xcouncilTableView from '../pages/xcouncil/views/table.json';
import xcouncilStagesView from '../pages/xcouncil/views/stages.json';
import xcouncilCardsView from '../pages/xcouncil/views/cards.json';
import xcouncilInlineView from '../pages/xcouncil/views/inline.json';
import xcouncilBacklogView from '../pages/xcouncil/views/backlog.json';
import xcouncilSplitView from '../pages/xcouncil/views/split.json';
import xcouncilCalendarView from '../pages/xcouncil/views/calendar.json';
import xcouncilDashboardView from '../pages/xcouncil/views/dashboard.json';

/** Тип запису «Експертна рада» зі сторінками пакета: меню, форми та подання з pages/xcouncil/. */
export const xcouncilDefinition: IRecordTypeDefinition = {
  ...xcouncilEntity,
  views: assembleViewSet({
      table: xcouncilTableView,
      stages: xcouncilStagesView,
      cards: xcouncilCardsView,
      inline: xcouncilInlineView,
      backlog: xcouncilBacklogView,
      split: xcouncilSplitView,
      calendar: xcouncilCalendarView,
      dashboard: xcouncilDashboardView,
  }),
  form: xcouncilFullForm,
  forms: { full: xcouncilFullForm, context: xcouncilContextForm, mini: xcouncilMiniForm, lookup: xcouncilLookupForm },
  menu: xcouncilMenu,
} as IRecordTypeDefinition;
